export default function Index() {
  return null;
}
